import React from 'react';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

/** This component is displayed when the user clicks on Decline Share action */
const DeclineConfirmationModal = ({
  closeConfirmationModal,
  handleDeclineShare,
  title,
}) => (
  <div className="confirmation-modal-wrapper">
    <ConfirmDialog
      title={title}
      content={{
        btnPrimary: 'Yes',
        btnSecondary: 'No',
      }}
      onClose={closeConfirmationModal}
      onSuccess={handleDeclineShare}
    >
      <p>
        If you decline this shared quiz, it will not appear in your Shared with
        Me list of quizzes. If you subsequently change your mind, you will have
        to go back to the source. <br />
        <span>Are you sure you want to decline it?</span>
      </p>
    </ConfirmDialog>
  </div>
);

export default DeclineConfirmationModal;
